import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const resetScroll = () => {
      window.scrollTo({ top: 0 });
    };
    const animationFrame = requestAnimationFrame(resetScroll);

    return () => {
      cancelAnimationFrame(animationFrame);
    };
  }, [pathname]);

  return <Outlet />;
}
